import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation.js";
import React from "react";

/**
 * Dynamically load translation files pertaining to the dashboard module.
 * @return {*}
 */
export default function useTranslationEmployerLanding() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/employer-landing.json'),
    'fr': import('./locales/fr/employer-landing.json')
  }), []);

  return useModuleTranslation('employer-landing', imports);
}
